package exchange.dydx.abacus.utils.beth32

data class Bech32Data(
    val humanReadablePart: String,
    val data: ByteArray
)
